import { AttendanceStatus } from '../../models/AttendanceItemStatus';
export var contentWrapper = 'flex items-center justify-between px-4 py-4 sm:px-6 ';
export var menuItemIconContainer = 'flex-shrink-0 h-12  w-12 rounded-full flex justify-center items-center ';
export var menuItemIconContainerDefault = 'bg-primary text-white';
export var menuItemIcon = 'flex-shrink-0 h-6 w-6 ';
export var menuTitle = 'text-sm font-medium text-primary truncate';
export var menuSubTitle = 'flex pl-0.5 items-center text-sm text-textLight';
export var attendanceIconPresent = 'h-6 w-6 text-successMain';
export var attendanceIconAbsent = 'h-6 w-6 text-errorMain';
export var presentListItemContainer = 'block bg-successBg cursor-pointer rounded-10';
export var absentListItemContainer = 'block bg-errorBg cursor-pointer rounded-10';
export var menulistItemContainer = function (status) {
    if (status) {
        switch (status) {
            case AttendanceStatus.Absent:
                return absentListItemContainer;
            case AttendanceStatus.Present:
                return presentListItemContainer;
            default:
                return presentListItemContainer;
        }
    }
    else {
        return presentListItemContainer;
    }
};
export var getColourByStatus = function (status) {
    if (status) {
        switch (status) {
            case AttendanceStatus.Absent:
                return attendanceIconAbsent;
            case AttendanceStatus.Present:
                return attendanceIconPresent;
            default:
                return attendanceIconPresent;
        }
    }
    else {
        return attendanceIconPresent;
    }
};
export var getShapeClassByAlertSeverity = function (type) {
    switch (type) {
        case 'error':
            return 'h-2.5 w-2.5 bg-errorMain';
        case 'warning':
            return 'h-0 w-0 border-opacity-0 border-t-0 border-l-5 border-l-tranparent border-r-5 border-r-tranparent border-b-10 border-b-alertMain shadow-none';
        case 'success':
            return 'h-2.5 w-2.5 rounded-full bg-successMain';
        default:
            return 'h-2.5 w-2.5 rounded-full bg-successMain';
    }
};
//# sourceMappingURL=attendance-list-item.styles.js.map